export default "assets/images/icons/phone-1e6c06ce.svg";